module.exports = "<div class=\"loadingScreen\" [ngClass]=\"{'opened' : isOpened, 'closed' : !isOpened}\">\r\n  <div class=\"outerCircle\">\r\n    <div class=\"innerCircle\">\r\n      <div class=\"accentCircle\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modals/loading-screen/loading-screen.component.html
// module id = ./src/app/modals/loading-screen/loading-screen.component.html
// module chunks = main